import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

interface Props {
  color?: string,
  size?: number,
  width?: number,
  height?: number,
  noPathStroke?: boolean,
  noPathFill?: boolean,
  noGFill?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseIcon',
  props: {
    color: { default: '#292929' },
    size: { default: 0 },
    width: { default: 0 },
    height: { default: 0 },
    noPathStroke: { type: Boolean },
    noPathFill: { type: Boolean },
    noGFill: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { color: string, size: number, width: number, height: number, noPathStroke?: boolean, noPathFill?: boolean, noGFill?: boolean };


const widthComp = computed(() =>
  props.width || props.size || 'auto'
)

const heightComp = computed(() =>
  props.height || props.size || 'auto'
)


return { __sfc: true,props, widthComp, heightComp }
}

})